export default "__VITE_ASSET__DLJPkhh0__"